var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"pa-2 pt-0 d-md-flex",attrs:{"cols":"12","md":"12"}},[_c('span',{staticClass:"font-weight-bold primary--text text-h6 pl-1"},[_vm._v(" "+_vm._s(_vm.$t(_vm.title))+" ")]),_vm._t("add")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }